import * as React from "react";
import * as _ from "lodash";
import { IMetricData } from "@curefit/metrics-common";
import { UserGoal, Goal } from "@curefit/gmf-common";
import IAllergyStaticData from "../../models/staticData/IAllergyStaticData";
import ModelFactory from "../../models/ModelFactory";
import TemplatedList from "../TemplatedList";
import ILifestyleGoal from "../../models/ILifestyleGoal";
import { default as CustomHeader, ICustomHeaderInfo } from "../utils/CustomHeader";
import IMetric from "../../models/metrics/IMetric";

let GoalNameHeaderInfos: ICustomHeaderInfo[] = [
    { label: "goal-name", display: "GOAL" }
];

interface HealthTargetsWrapperItemViewProps {
    goalsType?: string;
    item: UserGoal;
    staticGoals: Goal[];
    staticMetrics: IMetric[];
    onDataChange: (update: UserGoal) => any;
    allergiesStaticData: IAllergyStaticData;
    fetchAllergenByName: (allergen: string) => Promise<any>;
    patientMetrics: { [metricId: number]: IMetricData[] };
}
export default class HealthTargetsWrapperItemView extends React.Component<HealthTargetsWrapperItemViewProps> {
    constructor(props: HealthTargetsWrapperItemViewProps) {
        super(props);
    }
    onGoalMetricRemove = (index: number) => {
        let goalMetrics = Object.assign([], this.props.item.goalMetricTargets);
        goalMetrics.splice(index, 1);
        this.props.onDataChange({ ...this.props.item, goalMetricTargets: goalMetrics });
    }

    onGoalMetricChange = (updatedMetrics: { item: ILifestyleGoal }, index: number) => {
        let currUpdatedGoalMetrics = Object.assign([], this.props.item.goalMetricTargets);
        currUpdatedGoalMetrics[index] = updatedMetrics.item;
        this.props.onDataChange({ ...this.props.item, goalMetricTargets: currUpdatedGoalMetrics });
    }
    generateGoalMetricProp = () => {
        let goalMetricList: { item: ILifestyleGoal }[] = [];
        _.map(this.props.item.goalMetricTargets, (goalMetric, index) => {
            goalMetric.priority = index + 1;
            goalMetricList.push({ item: goalMetric as ILifestyleGoal });
        })
        return goalMetricList;
    }
    /*generateGoalItems = () => {
        let goalItems: IStaticDataValue[] = [];
        _.map(this.props.staticGoals, (goal: IGoal) => {
            goalItems.push({ internalValue: goal._id, displayValue: goal.name });
        })
        return goalItems;
    }
    updateGoalItem = (value: string) => {
        this.props.onDataChange({ ...this.props.item, goalId: value })
    }
    secondaryGoalNameChange = (evt: any) => {
        this.props.onDataChange({ ...this.props.item, goalName: evt.target.value })
    }*/
    getGoalIdFromGoalName = (goalId: string) => {
        let goals = Object.values(this.props.staticGoals);
        let goalIds = goals.map(item => _.get(item, "_id"));
        let index = goalIds.indexOf(goalId);
        if (index !== -1) return goals[index].name;
        else return "";
    }
    generateStaticMetrics = () => {
        let selectedGoalId = this.props.item.goalId;
        // let staticMetrics = this.props.staticMetrics;
        let staticMetrics = {} as any;
        if (this.props.goalsType === "PRIMARY" && !_.isEmpty(selectedGoalId)) {
            let goals = Object.values(this.props.staticGoals);
            let goalIds = goals.map(item => _.get(item, "_id"));
            let index = goalIds.indexOf(selectedGoalId);
            let metrics = goals[index].allowedMetricIds;

            let count = 0;
            _.map(this.props.staticMetrics, (metric: IMetric) => {
                if (metrics.indexOf(metric.id) !== -1) {
                    staticMetrics[count] = metric;
                }
                count++;
            });
        }
        return staticMetrics;
    }
    render() {
        let listItems = this.generateGoalMetricProp();
        let selectedGoal = !_.isEmpty(this.props.item.goalId) ? this.getGoalIdFromGoalName(this.props.item.goalId) : null;
        let isGoalCancelled = !_.isEmpty(this.props.item.editInfo) && this.props.item.editInfo.nextStatus === "CANCELLED" ? "cancelled" : "";
        return <div className={`health-target-goal-item-container ${isGoalCancelled}`}>
            <CustomHeader headerInfos={GoalNameHeaderInfos} rootCls={"patient-goal-name-header"} />
            {
                this.props.goalsType === "PRIMARY" &&
                <div className={"health-target-goal-name-container"}>
                    {/*<TextInput name={"health-target-goal-name"}/>*/}
                    <span>{selectedGoal}</span>
                </div>
            }
            {
                this.props.goalsType === "OTHER" &&
                <div className={"health-target-goal-name-container"}>
                    <span>{this.props.item.goalName}</span>
                </div>
            }
            {
                this.props.goalsType === "PRIMARY" &&
                <TemplatedList templateName={"healthTargetView"} commonProps={{
                    goalsType: this.props.goalsType,
                    startDate: this.props.item.startEpoch, staticMetrics: this.generateStaticMetrics(), patientMetrics: this.props.patientMetrics
                }}
                    defaultItem={{ item: ModelFactory.createNewLifestyleGoal() }}
                    listItems={listItems}
                    onItemRemove={this.onGoalMetricRemove}
                    onItemChange={this.onGoalMetricChange}
                    preventRowAddition={true} hideRemoveBtn={true}
                    autoAddNewRow={false} addRowText={"+ Add a metric"} />
            }
        </div>
    }
}